/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactListResponseData,
  CreateContactListResponseDataFromJSON,
  CreateContactListResponseDataFromJSONTyped,
  CreateContactListResponseDataToJSON
} from './CreateContactListResponseData'

/**
 *
 * @export
 * @interface AppendContactListResponse
 */
export interface AppendContactListResponse {
  /**
   *
   * @type {number}
   * @memberof AppendContactListResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactListResponseData}
   * @memberof AppendContactListResponse
   */
  data?: CreateContactListResponseData
}

export function AppendContactListResponseFromJSON(json: any): AppendContactListResponse {
  return AppendContactListResponseFromJSONTyped(json, false)
}

export function AppendContactListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendContactListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactListResponseDataFromJSON(json['data'])
  }
}

export function AppendContactListResponseToJSON(value?: AppendContactListResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactListResponseDataToJSON(value.data)
  }
}
